import { useEffect, useState } from "react";
import { Backdrop, Box, Container, makeStyles } from "@material-ui/core";
import Page from "../../../support/page/Page";
import Results from "./Results";
import getAllEnquiries from "../../../../services/enquiry";
import store from "../../../../redux/store/store";
import _ from "lodash";
import {
  emptyEnquiries,
  fetchEnquiries,
} from "../../../../redux/actions/enquiry";
import CircularProgressBar from "../../../support/progress/CircularProgressBar";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "85%",
    paddingBottom: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const EnquiryListView = () => {
  const classes = useStyles();

  useEffect(() => {
    async function fetchData() {
      handleBackDropOpen();
      const result = await getAllEnquiries();
      if (result.status === "success") {
        const sortedSrList = _.sortBy(
          [...result.docs],
          [
            function (o) {
              return o.docData.referenceId;
            },
          ]
        ).reverse();
        store.dispatch(fetchEnquiries([...sortedSrList]));
        handleBackDropClose();
      } else {
        handleBackDropClose();
      }
    }
    fetchData();
    return function cleanup() {
      store.dispatch(emptyEnquiries());
    };
  }, []);

  const [openBackdrop, setOpenBackdrop] = useState(false);

  function handleBackDropClose() {
    setOpenBackdrop(false);
  }

  function handleBackDropOpen() {
    setOpenBackdrop(true);
  }
  return (
    <>
      <Page className={classes.root}>
        <Container maxWidth={false}>
          <Box mt={1}>{<Results />}</Box>{" "}
        </Container>{" "}
        <Backdrop className={classes.backdrop} open={openBackdrop}>
          <CircularProgressBar display={true} />
        </Backdrop>
      </Page>
    </>
  );
};

export default EnquiryListView;
